import React from "react"
import SettingsContainer from "@geome/shell-locator-components/lib/containers/settings"
import SettingsBase from "@geome/shell-locator-components/lib/components/settings"
import { translate } from "@geome/intl"

const Settings = (props) => (
  <SettingsContainer>
    {(viewProps) => {
      const supportedLocales = LANGUAGE_LISTS[viewProps.currentLocale] ?? viewProps.supportedLocales
      return (
        <SettingsBase {...viewProps} supportedLocales={supportedLocales} translate={translate} />
      )
    }}
  </SettingsContainer>
)

const LANGUAGE_LISTS = {
  ar_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  fr_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  nl_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  en_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  de_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  it_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  pl_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  pt_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  tr_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  es_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
  ur_MA: [
    "ar_MA",
    "nl_MA",
    "en_MA",
    "fr_MA",
    "de_MA",
    "it_MA",
    "pl_MA",
    "pt_MA",
    "es_MA",
    "tr_MA",
    "ur_MA",
  ],
}

export default Settings
